import React, { useEffect, useState } from 'react';
import { Sparkle } from '@phosphor-icons/react';
import { useLocation } from 'react-router-dom';
import { usePortfolio } from '../context/PortfolioContext';
export function FloatingButtons() {
  const location = useLocation();
  const {
    openChatDrawer,
    setChatEntryPoint
  } = usePortfolio();
  const [isInHero, setIsInHero] = useState(true);
  // Check if we're on a case study page
  const isCaseStudyPage = location.pathname.includes('/case-study/');
  // ADDED: Check if user came from chat
  const cameFromChat = sessionStorage.getItem('cameFromChat') === 'true';
  // Track if user is in hero section (only for non-case-study pages)
  useEffect(() => {
    if (isCaseStudyPage) {
      setIsInHero(false);
      return;
    }
    const handleScroll = () => {
      const heroSection = document.getElementById('home');
      if (heroSection) {
        const heroBottom = heroSection.offsetTop + heroSection.offsetHeight;
        const scrollPosition = window.scrollY + window.innerHeight / 2;
        setIsInHero(scrollPosition < heroBottom);
      }
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [location.pathname, isCaseStudyPage]);
  // Show chat button when not in hero OR on case study pages (always show on case studies)
  const shouldShowChatButton = !isInHero || isCaseStudyPage;
  const handleChatClick = () => {
    setChatEntryPoint(location.pathname);
    openChatDrawer();
    if (typeof window !== 'undefined' && (window as any).gtag) {
      ;
      (window as any).gtag('event', 'chat_opened', {
        event_category: 'Chat',
        event_label: 'Floating Button',
        source: 'floating_button'
      });
    }
  };
  return <>
      {/* AI Chat Button - Bottom Right Corner */}
      {shouldShowChatButton && <div className={`fixed right-4 sm:right-5 block ${isCaseStudyPage ? 'bottom-24 lg:bottom-5' : 'bottom-5'}`} style={{
      zIndex: 99999,
      paddingBottom: 'env(safe-area-inset-bottom, 0px)'
    }} data-id="element-236">
          <button onClick={handleChatClick} className="flex items-center gap-2 px-5 py-3 bg-black/85 backdrop-blur-sm border border-white/20 rounded-full text-white text-sm font-medium transition-all duration-200 hover:bg-black/95 hover:border-white/30 hover:shadow-xl active:scale-95 shadow-lg" aria-label="Open AI Chat" data-id="element-237">
            <Sparkle className="w-4 h-4" weight="fill" data-id="element-238" />
            <span data-id="element-239">AI Chat</span>
          </button>
        </div>}

      {/* Remove old styles */}
      <style data-id="element-240">{`
        /* Styles removed - using simple Tailwind classes now */
      `}</style>
    </>;
}